export default {
  title: "My Images",
  countLabel: "{count} images",
  uploadFloating: "Upload photo",
  group: {
    referenceCount: "{count} style | {count} styles",
  },
  referenceCreate: {
    ariaLabel: "Create analysis with another reference",
    loadingTitle: "Preparing your photo",
    loadingMessage: "Restoring the original image before reference selection.",
    failedTitle: "Unable to reuse this photo",
    failedMessage:
      "The local cached image is unavailable. Please upload the photo again.",
    networkError:
      "Network error: unable to fetch the original image. Please try again later.",
  },
  dateFilter: {
    timeFilter: "Filter by date",
    clearFilter: "Clear date filter",
    allTime: "All time",
    last7Days: "Last 7 days",
    last30Days: "Last 30 days",
    noData: "No date data available",
  },
  empty: {
    title: "No images found",
    description: "Start uploading to see your images here",
    uploadAction: "Start uploading",
    descriptionSuffix: " to see your images here",
  },
  error: {
    title: "Couldn't sync your history",
    description: "We couldn't reach the server to refresh your images.",
    retry: "Try again",
    uploadAction: "Start uploading",
  },
  filteredEmpty: {
    title: "No images match this filter",
    description:
      "Try a different date range or clear the filter to see all your images.",
  },
  loading: "History Loading",
  loadingMore: "Loading More",
  syncWarning:
    "We couldn't fully sync your history. Showing your locally cached images.",
  deleteConfirm: {
    header: "Confirm Deletion",
    message:
      "Are you sure you want to delete this upload group and all linked references? This action cannot be undone.",
    accept: "Delete",
    acceptPending: "Deleting…",
    reject: "Cancel",
    close: "Close",
  },
  sheet: {
    title: "Photo actions",
    openResult: "Open original result",
    referenceList: "Styles",
    createReference: "Create with another reference",
    delete: "Delete this record",
    close: "Close",
    count: "{count} style | {count} styles",
  },
};
